import { render } from "./Spiner.vue?vue&type=template&id=46883e2c"
import script from "./Spiner.vue?vue&type=script&lang=js"
export * from "./Spiner.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__